<template>
    <view-with-bar>
        <template slot="bar">
            <view-bar>
                <h1>{{ $t('parties.parties') }}</h1>
                <view-bar-item route="/parties">{{ $t('parties.partyListing') }}</view-bar-item>
                <h1>{{ $t('parties.creditRisk') }}</h1>
                <view-bar-item route="/parties/credit-risk">{{ $t('parties.creditRiskManagement') }}</view-bar-item>
            </view-bar>
        </template>
    </view-with-bar>
</template>

<script>
    import ViewWithBar from "../components/layout/ViewWithBar";
    import ViewBar from "../components/navigation/ViewBar";
    import ViewBarItem from "../components/navigation/ViewBarItem";
    import {mapGetters} from "vuex";
    export default {
        name: "PartyManagementView",
        components: {ViewBarItem, ViewBar, ViewWithBar},
    }
</script>

<style scoped>

</style>